module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coures-container"
  }, [_c('div', {
    staticClass: "courseDetails",
    attrs: {
      "onclick": "_hmt.push(['_trackEvent', 'website', 'click', '点击'])"
    }
  }, [_c('meta', {
    attrs: {
      "name": "keywords",
      "content": _vm.courseName + '+' + _vm.introduce + '+' + '以诺教育;诺亚财富'
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('title', [_vm._v(_vm._s(_vm.name) + "-以诺教育")]), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('Breadcrumb', {
    staticClass: "crumbs",
    attrs: {
      "separator": "<span class='demo-breadcrumb-separator'>></span>"
    }
  }, [_c('BreadcrumbItem', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('BreadcrumbItem', {
    attrs: {
      "href": "/courseList"
    }
  }, [_vm._v("全部课程")]), _vm._v(" "), _c('BreadcrumbItem', {
    attrs: {
      "href": "/courseList"
    }
  }, [_vm._v(_vm._s(_vm.zhClasses))]), _vm._v(" "), _c('BreadcrumbItem', {
    staticStyle: {
      "color": "#909090",
      "font-weight": "normal"
    }
  }, [_vm._v("课程详情")])], 1), _vm._v(" "), _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.zzz,
      "autoplaySpeed": 5000,
      "arrow": "hover",
      "dots": "none"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, [_c('CarouselItem', [_c('div', {
    staticClass: "splitScreen"
  }, [_c('img', {
    attrs: {
      "src": _vm.courseSystemBanner,
      "alt": "人生哲学·去远方·课程体系"
    }
  })])]), _vm._v(" "), _vm._l((_vm.listB), function(item, index) {
    return _c('CarouselItem', {
      key: item.id
    }, [_c('div', {
      staticClass: "splitScreen"
    }, [(_vm.shipin ? true : false) ? _c('video', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 0 ? true : false),
        expression: "index==0?true:false"
      }],
      staticStyle: {
        "position": "absolute"
      },
      attrs: {
        "id": "v1",
        "src": _vm.shipin,
        "controls": "controls",
        "height": "100%",
        "width": "500",
        "onerror": "alert('网速不好')",
        "preload": ""
      }
    }, [_c('div', {
      staticClass: "videoplay"
    }, [_vm._v("该浏览器不支持视频播放 ^_^")])]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.url
      }
    })])])
  })], 2)], 1), _vm._v(" "), _vm._l((_vm.foundation), function(infoT) {
    return _c('div', {
      key: infoT.name,
      staticClass: "content1"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(infoT.name))]), _vm._v(" "), _c('div', {
      staticClass: "information"
    }, _vm._l((_vm.introduce), function(v) {
      return _c('div', {
        key: v,
        staticClass: "introduce"
      }, [_vm._v(_vm._s(v))])
    })), _vm._v(" "), _c('div', {
      staticClass: "informationTow"
    }, [_c('li', {
      staticClass: "membership"
    }, [_vm._v("\n            " + _vm._s(infoT.price_type) + "\n            "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.huang),
        expression: "huang"
      }],
      staticClass: "heika",
      attrs: {
        "src": require("../../assets/heika.png")
      },
      on: {
        "mouseenter": _vm.enter,
        "mouseleave": _vm.leave
      }
    }), _vm._v(" "), _c('b', {
      staticClass: "membershipValue"
    }, [_vm._v(_vm._s(infoT.price))]), _vm._v(" \n            "), _c('span', [_vm._v("元/人")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.member),
        expression: "member"
      }],
      staticClass: "marketvalue"
    }, [_vm._v(_vm._s(infoT.market_price) + "元/人")]), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }), _vm._v(" "), (_vm.couponzzz) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.coupones.length == 0 ? false : true),
        expression: "coupones.length==0?false:true"
      }],
      staticClass: "coupon"
    }, [_c('p', {
      staticClass: "couponWord"
    }, [_vm._v("优惠")]), _vm._v(" "), _c('ul', {
      staticClass: "prize"
    }, _vm._l((_vm.coupones), function(hui, index) {
      return _c('li', {
        key: index,
        staticClass: "prizeChild"
      }, [_c('span', {
        staticClass: "fullCut"
      }, [_vm._v(_vm._s(hui.classify))]), _vm._v(" "), _c('a', {
        attrs: {
          "disabled": _vm.receiveOne
        },
        on: {
          "click": function($event) {
            _vm.couponss(hui)
          }
        }
      }, [_vm._v(_vm._s(hui.name))]), _vm._v(" "), _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index == 1 ? true : false),
          expression: "index==1?true:false"
        }]
      }, [_c('Icon', {
        staticClass: "dropDown",
        attrs: {
          "type": "arrow-up-b"
        }
      })], 1), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.popup),
          expression: "popup"
        }],
        staticClass: "popup"
      }, _vm._l((_vm.couponess), function(quan) {
        return _c('div', {
          key: quan.name,
          staticClass: "receive"
        }, [_c('p', {
          on: {
            "click": _vm.closes
          }
        }, [_c('Icon', {
          staticClass: "abrog",
          attrs: {
            "type": "close"
          }
        })], 1), _vm._v(" "), _c('p', {
          staticClass: "receiveWord"
        }, [_vm._v(_vm._s(_vm.receive))]), _vm._v(" "), _c('div', {
          staticClass: "Vouchers"
        }, [_c('div', {
          staticClass: "VouchersLeft"
        }, [_c('div', {
          staticClass: "amountNumber"
        }, [_c('span', [_vm._v(_vm._s(quan.price))]), _vm._v(" 元\n                        "), _c('i', [_vm._v(_vm._s(quan.name))])]), _vm._v(" "), _c('p', {
          staticClass: "moneyTime"
        }, [_vm._v(_vm._s(quan.range))]), _vm._v(" "), _c('p', {
          staticClass: "moneyTime"
        }, [_vm._v("有效期：" + _vm._s(quan.time_out))])]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
          staticClass: "Determine",
          on: {
            "click": _vm.closes
          }
        }, [_vm._v("确认，继续报名>")])])
      }))])
    })), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "place"
    }, [_vm._v("\n          地点\n          "), _c('span', [_vm._v(_vm._s(infoT.address))])]), _vm._v(" "), _c('div', {
      staticClass: "couseTime"
    }, [_vm._v("\n          课程时间\n          "), _c('span', [_vm._v(_vm._s(infoT.classes_begin) + " 至 " + _vm._s(infoT.classes_end))])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "signUp"
      },
      on: {
        "click": function($event) {
          _vm.subscribe()
        }
      }
    }, [_c('div', {
      staticClass: "signUp"
    }, [_vm._v("立即咨询")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.jie),
        expression: "jie"
      }],
      staticClass: "signupEnd"
    }, [_vm._v("报名截止" + _vm._s(_vm.countdown) + "天")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "details",
    attrs: {
      "id": "introduct"
    }
  }, [_c('p', {
    staticClass: "subject"
  }, [_vm._v("课程简介")]), _vm._v(" "), _c('p', {
    staticClass: "jianjie"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "arrange"
    }
  }, [_c('div', {
    staticClass: "scheduleTt"
  }, [_c('p', {
    staticClass: "subject"
  }, [_vm._v("详情介绍")]), _vm._v(" "), _vm._l((_vm.course), function(ke) {
    return _c('img', {
      key: ke.url,
      staticClass: "scheduleP",
      attrs: {
        "src": ke.url
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "details",
    attrs: {
      "id": "refund"
    }
  }, [_c('p', {
    staticClass: "subject"
  }, [_vm._v("报名须知")]), _vm._v(" "), _c('div', {
    staticClass: "richtext",
    domProps: {
      "innerHTML": _vm._s(_vm.richtext)
    }
  })])], 1), _vm._v(" "), _c('Bottom'), _vm._v(" "), _c('div', {
    staticClass: "right-buttons"
  }, [_c('div', {
    staticClass: "right-button",
    class: _vm.buttonIndex == 1 ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.closeSubOnline();
        _vm.openConsult();
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-nav_pc-icon_zaixianyuyue"
  }), _vm._v(" "), _c('p', [_vm._v("在线咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button",
    class: _vm.buttonIndex == 2 ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.closeSubOnline();
        _vm.buttonIndex = 2;
      },
      "mouseleave": function($event) {
        $event.preventDefault();
        _vm.buttonIndex == 2 ? _vm.buttonIndex = null : ''
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-nav_pc-icon_zixundianhua"
  }), _vm._v(" "), _c('p', [_vm._v("电话咨询")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonIndex == 2),
      expression: "buttonIndex == 2"
    }],
    staticClass: "serverPhone"
  }, [_c('p', {
    staticClass: "kefuphone"
  }, [_vm._v("400-820-0025")]), _vm._v(" "), _c('p', {
    staticClass: "zhuanxian"
  }, [_vm._v("拨通转6号线进入专线")])]), _vm._v(" "), (_vm.buttonIndex == 1) ? _c('div', {
    staticClass: "iframe-container",
    on: {
      "click": function($event) {
        _vm.buttonIndex = null;
        _vm.iframeLoaded = false
      }
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.iframeLoaded),
      expression: "!iframeLoaded"
    }],
    attrs: {
      "fix": ""
    }
  }, [_c('Icon', {
    staticClass: "demo-spin-icon-load",
    attrs: {
      "type": "load-c",
      "size": "18"
    }
  }), _vm._v(" "), _c('div', [_vm._v("加载中")])], 1), _vm._v(" "), _c('iframe', {
    attrs: {
      "id": "consult-ol",
      "frameborder": "0",
      "width": "600px",
      "height": "600px",
      "src": _vm.iframeSrc
    },
    on: {
      "load": function($event) {
        _vm.iframeLoad()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.subOnlineClose) ? _c('div', {
    staticClass: "sub-online-container",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.buttonIndex = null;
        _vm.closeSubOnline()
      }
    }
  }, [_c('div', {
    staticClass: "sub-online"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("在线预约免费领取课程资料")]), _vm._v(" "), _c('Form', {
    attrs: {
      "model": _vm.subscribeForm
    }
  }, [_c('FormItem', [_c('Input', {
    attrs: {
      "disabled": true,
      "size": "large"
    },
    model: {
      value: (_vm.subscribeForm.className),
      callback: function($$v) {
        _vm.subscribeForm.className = $$v
      },
      expression: "subscribeForm.className"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入姓名",
      "disabled": !!_vm.userName,
      "size": "large"
    },
    model: {
      value: (_vm.subscribeForm.name),
      callback: function($$v) {
        _vm.subscribeForm.name = $$v
      },
      expression: "subscribeForm.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号",
      "disabled": !!_vm.userPhone,
      "size": "large",
      "maxlength": 11
    },
    on: {
      "on-change": _vm.FormPhoneChange
    },
    model: {
      value: (_vm.subscribeForm.phone),
      callback: function($$v) {
        _vm.subscribeForm.phone = $$v
      },
      expression: "subscribeForm.phone"
    }
  })], 1), _vm._v(" "), (_vm.needCaptcha) ? _c('FormItem', {
    staticClass: "tuCode"
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "13"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入图形验证码",
      "size": "large"
    },
    model: {
      value: (_vm.subscribeForm.captcha),
      callback: function($$v) {
        _vm.subscribeForm.captcha = $$v
      },
      expression: "subscribeForm.captcha"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "9"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.captcha,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.captchaGet()
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.token) ? _c('FormItem', {
    staticClass: "code"
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "13"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入验证码",
      "size": "large"
    },
    model: {
      value: (_vm.subscribeForm.code),
      callback: function($$v) {
        _vm.subscribeForm.code = $$v
      },
      expression: "subscribeForm.code"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "9"
    }
  }, [_c('Button', {
    class: {
      'disable': _vm.fasong || !_vm.subPhone
    },
    attrs: {
      "disabled": _vm.fasong || !_vm.subPhone
    },
    on: {
      "click": function($event) {
        _vm.codeNumber()
      }
    }
  }, [_vm._v("\n                获取验证码\n                "), (_vm.fasong) ? _c('span', [_vm._v(_vm._s(_vm.time))]) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userCode) ? _c('p', {
    staticClass: "errormessage sser"
  }, [_vm._v(_vm._s(_vm.errormess))]) : _vm._e(), _vm._v(" "), _c('FormItem', {
    staticClass: "submit"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("立即提交")])], 1)], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Dhide"
  }, [_c('div', {
    staticClass: "triangle"
  }), _vm._v(" "), _c('div', {
    staticClass: "blackCard"
  }, [_vm._v("黑卡用户不能同时享受其他优惠，如果对优惠有疑问，请联系客服处理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VouchersRight"
  }, [_vm._v("\n                      已\n                      "), _c('br'), _vm._v("领\n                      "), _c('br'), _vm._v("取\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "synopsis"
  }, [_c('div', {
    staticClass: "tableB active",
    attrs: {
      "id": "one"
    }
  }, [_vm._v("课程简介")]), _vm._v(" "), _c('div', {
    staticClass: "tableB",
    attrs: {
      "id": "two"
    }
  }, [_vm._v("详情介绍")]), _vm._v(" "), _c('div', {
    staticClass: "tableB",
    attrs: {
      "id": "three"
    }
  }, [_vm._v("报名须知")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16f20ceb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseDetails/CourseDetails.vue
// module id = 540
// module chunks = 1